import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

import { ds } from '@/components/lib/design.system';
import { designSystem } from '@/styles/styles';

function SvgComponent(props) {
    return (
        <Svg width={62} height={81} viewBox="0 0 62 81" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <Path
                d="M55.232.75l.32 1.429c-12.723 6-24.427 15.253-30.508 24.965 3-1.798 6.623-2.825 10.592-2.825 13.375 0 25.614 11.225 25.614 26.75 0 15.274-11.04 29.181-29.513 29.181-9.449 0-17.216-3.237-22.618-8.982C3.722 65.527.75 57.35.75 47.58.75 30.188 11.855 10.058 29.493.835l.164-.085h25.575zM30.79 40.299c-3.14 0-5.866 1.098-7.805 3.043-1.937 1.943-3.14 4.783-3.14 8.361 0 3.634 1.204 6.5 3.141 8.456 1.939 1.957 4.664 3.055 7.804 3.055 3.085 0 5.812-1.097 7.766-3.057 1.951-1.957 3.18-4.824 3.18-8.454 0-3.574-1.227-6.415-3.178-8.36-1.955-1.948-4.683-3.044-7.768-3.044z"
                fill={designSystem.colors.neutral900}
                stroke={ds.colorValue.icon.brand}
                strokeWidth={1.5}
            />
        </Svg>
    );
}

export default SvgComponent;
